import { render, staticRenderFns } from "./OCR_recognition.vue?vue&type=template&id=5868b6cd&scoped=true"
import script from "./OCR_recognition.vue?vue&type=script&lang=js"
export * from "./OCR_recognition.vue?vue&type=script&lang=js"
import style0 from "./OCR_recognition.vue?vue&type=style&index=0&id=5868b6cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5868b6cd",
  null
  
)

export default component.exports